import { CSSProperties } from "@material-ui/core/styles/withStyles";
export { time } from "@clockwise/web-commons/src/styles/color.styles";
export { label } from "@components/week-in-review-scrubber/WeekInReviewScrubber.styles";

export const slot: CSSProperties = {
  height: 30,
  width: `100%`,
  transition: "background-color .75s",
};

export const dayContainer: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  width: 30,
};

export const snapshotContainer: CSSProperties = {
  display: "grid",
  gridTemplateRows: "30px 100px",
  gridTemplateColumns: "auto auto auto auto auto",
  gridGap: "10px",
};
